<template>
  <div class="cxm-EditPicture">
    <TResizeImage
      v-if="questionData.url"
      :image="questionData.url"
      :callback="resizedImage"
      style="display: flex"
      :style="{ 'justify-content': resizeAlign }"
      :position="questionData.align"
      max-height="auto"
    />
    <div
      v-else
      :style="{ 'text-align': questionData.align }"
    >
      <img
        src="survey/image-icon.svg"
      >
    </div>
  </div>
</template>

<script>
import TResizeImage from '@/components/ResizeImage.vue';

export default {
  components: { TResizeImage },
  props: {
    questionData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    resizeAlign() {
      if (this.questionData.align === 'right') {
        return 'flex-end';
      }
      if (this.questionData.align === 'left') {
        return 'flex-start';
      }
      return 'center';
    },
  },
  methods: {
    resizedImage(imageUrl) {
      this.questionData.url = imageUrl;
      if (!this.questionData.extension) {
        this.questionData.extension = 'png';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-EditPicture {
  width: 100%;
}
</style>
